import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type ModalVariant = 'success' | 'error' | 'warning' | 'info';

type UiModalState = {
  show: boolean;
  variant: ModalVariant;
  title: string;
  message: string | null;
};

const initialState: UiModalState = {
  show: false,
  variant: 'info',
  title: '',
  message: null,
};

const uiModalSlice = createSlice({
  name: 'uiModal',
  initialState,
  reducers: {
    openModal: (
      state,
      action: PayloadAction<{
        variant?: ModalVariant;
        title?: string;
        message?: string | null;
      }>
    ) => {
      const { variant, title, message } = action.payload;
      state.show = true;
      state.variant = variant ?? 'info';
      state.title = title ?? '';
      state.message = message ?? null;
    },
    closeModal: (state) => {
      state.show = false;
      state.message = null;
    },
  },
});

export const { openModal, closeModal } = uiModalSlice.actions;
export default uiModalSlice.reducer;
